module.exports = __webpack_public_path__ + "img/hr-H-B-6-load-connect-shadow.3d4416dc.png";